import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

export const textButtonBaseStyle = css`
  background: transparent;
  border: 2px solid transparent;
  border-radius: 2px;
  color: ${theme.colors.neutral90};
  cursor: pointer;
  font-family: ${theme.font.family};
  font-size: ${theme.fontSize(14)};
  padding: ${theme.spacing(0.5, 1)};
  transition: background border-radius 250ms ease-out, border-color 250ms ease-out;

  &:hover,
  &:focus {
    background-color: ${theme.colors.neutral5};
    border-color: ${theme.colors.neutral5};
  }

  &:focus {
    outline-color: ${theme.colors.primary50};
    outline-offset: 5px;
    outline-width: 2px;
  }

  &:active {
    background-color: ${theme.colors.neutral10};
    border-color: ${theme.colors.neutral10};
    outline: none;
  }

  &:disabled {
    background: transparent;
    border-color: transparent;
    color: ${theme.colors.neutral20};
    cursor: default;
  }
`;

export const hasIconStyle = css`
  align-items: center;
  display: flex;

  svg {
    margin-right: ${theme.spacing(1)};
  }
`;

export const textButtonVariantStyles = {
  rounded: css`
    border-radius: ${theme.borderRadius.small};
    padding: ${theme.spacing(1)};

    &:hover,
    &:focus {
      background-color: ${theme.colors.neutral20};
      border-color: ${theme.colors.neutral20};
    }
  `,
  'rounded-small': css`
    font-size: ${theme.fontSize(12)};
    border-radius: ${theme.borderRadius.small};

    &:hover,
    &:focus {
      background-color: ${theme.colors.neutral20};
      border-color: ${theme.colors.neutral20};
    }
  `,
};
